import { useDispatch, useSelector } from "react-redux";
import ReactSlider from "react-slider";
import { setPriceRange } from "../../../redux/filtersSlice";
import { useEffect, useState, useMemo } from "react";

function RangeSlider({ label, min = 0, max = 1000, filterId }) {
  const dispatch = useDispatch();
  const drawerOpen = useSelector((state) => state.view.drawer);

  // Get the priceRange from Redux state
  const minPrice = Number(min);
  const maxPrice = Number(max);
  const step = Math.max(1, Math.round((maxPrice - minPrice) / 1000));
  const adjustedMinPrice = Math.floor(minPrice / step) * step;
  const adjustedMaxPrice = Math.ceil(maxPrice / step) * step;

  // Use useMemo to prevent initialRange from changing on every render
  const initialRange = useMemo(
    () => [adjustedMinPrice, adjustedMaxPrice],
    [adjustedMinPrice, adjustedMaxPrice],
  );

  const priceRange = useSelector(
    (state) => state.filters.priceRange[filterId] || initialRange,
  );

  // Use local state to track changes while sliding
  const [tempRange, setTempRange] = useState(priceRange);

  // Handle range change during sliding
  const handlePriceRangeChange = (values) => {
    setTempRange(values); // Track values while sliding
  };

  // Apply range change after sliding stops
  const handlePriceRangeCommit = (values) => {
    dispatch(setPriceRange({ filterId, priceRange: values }));
  };

  useEffect(() => {
    // Dispatch the action to reset price range to initialRange when min or max changes
    setTempRange(initialRange);
    // dispatch(setPriceRange({ filterId:filterId, priceRange: initialRange }));
  }, [dispatch, min, max, initialRange]);

  return (
    <div className={`${drawerOpen ? "" : "hidden"}`}>
      <h3 className="font-bold text-sm text-primeColor mb-4 capitalize">
        Price Range
      </h3>
      <div className="relative flex items-center">
        <ReactSlider
          value={tempRange} // Bind to local state for sliding
          onChange={handlePriceRangeChange} // Track changes while sliding
          onAfterChange={handlePriceRangeCommit} // Apply after sliding stops
          min={minPrice}
          max={maxPrice}
          step={step}
          renderTrack={(props, state) => (
            <div {...props} className="bg-gray-200 h-4 rounded-full" />
          )}
          renderThumb={(props) => (
            <div
              {...props}
              style={{
                ...props.style,
                zIndex: 0,
              }}
              className="w-4 h-4 bg-blue-500 rounded-full"
            />
          )}
          className="w-full mt-2"
          minDistance={step}
        />
        <div className="absolute bottom-1 w-full flex justify-between text-xs mt-2">
          <span>{tempRange[0]}</span>
          <span>{Number(tempRange[1])}</span>
        </div>
      </div>
    </div>
  );
}

export default RangeSlider;
